import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions } from '@mui/material';
import Button from '@mui/material/Button';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { formatPhoneNumber, justNumbers } from '../utils/PhoneNumber';

const ContactInfoDialog = ({ open, toggle, confirm }) => {

  const initialField = { value: '', isValid: false, validationMessage: '' }
  const initialContact = { name: { ...initialField }, phone: { ...initialField, pattern: '^\\(?(\\d{3})\\)?[- ]?(\\d{3})[- ]?(\\d{4})$' } };
  const [contact, setContact] = useState(initialContact);

  const setFieldValue = (field, value) => {
    setContact(prev => ({...prev, [field]: { ...prev[field], value }}))
  }

  const setIsValid = (field, isValid, validationMessage) => {
    setContact(prev => ({...prev, [field]: { ...prev[field], isValid, validationMessage }}))
  }
  
  const handleConfirm = (event) => {
    confirm({ contactName: contact.name.value, contactPhone: contact.phone.value });
    toggle(event);
  }

  const handleClose = (event) => {
    toggle(event);
  }

  const handleInputChange = (e, field, transform = value => value) => {
    if(field === 'phone') {
      setFieldValue(field, justNumbers(e.target.value));
    } else {
      setFieldValue(field, transform(e.target.value));
    }
  }

  const handleInputBlur = (e, field) => {
    setFieldValue(field, e.target.value?.trim());
  }

  useEffect(() => {
    if (!contact.name.value?.trim()) {
      setIsValid('name', false, 'Required')
      return;
    }

    if (contact.name.value.length < 3) {
      setIsValid('name', false, 'At least 3 characters')
      return;
    }

    setIsValid('name', true, '')

  }, [contact.name.value])

  useEffect(() => {
    if (!contact.phone.value?.trim()) {
      setIsValid('phone', false, 'Required')
      return;
    }

    if (!new RegExp(contact.phone.pattern).test(contact.phone.value)) {
      setIsValid('phone', false, 'Invalid phone number');
      return;
    }

    setIsValid('phone', true, '')

  }, [contact.phone.value])

  return (
    <Dialog 
      open={open} 
      onClose={() => handleClose('byCancel')}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle><b>Call Store</b></DialogTitle>
      <DialogContent>
        <DialogContentText className='break-words mb-2'>
          Please call {contact.name.value || 'NAME'} at Les Schwab store { formatPhoneNumber(contact.phone.value) || 'PHONE #'}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="contactName"
          label="Contact name"
          type="text"
          fullWidth
          variant="outlined"
          value={contact.name.value}
          onChange={e => handleInputChange(e, 'name', value => value?.toUpperCase())}
          required={true}
          error={!contact.name.isValid}
          helperText={contact.name.validationMessage}
          inputProps={{ 
            style: { textTransform: 'uppercase' }, 
            onBlur: e => handleInputBlur(e, 'name'),
            minLength: 3,
            maxLength: 25
          }}
        />
        <TextField
          margin="dense"
          id="contactPhone"
          label="Contact phone"
          type="tel"
          fullWidth
          variant="outlined"
          value={formatPhoneNumber(contact.phone.value)}
          onChange={e => handleInputChange(e, 'phone')}
          required={true}
          error={!contact.phone.isValid}
          helperText={contact.phone.validationMessage}
          inputProps={{ 
            inputMode: 'tel', 
            pattern: contact.phone.pattern, 
            onBlur: e => handleInputBlur(e, 'phone'),
            maxLength: 10 
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button 
          onClick={() => handleClose('byCancel')} 
          className='shadow-sm px-3 py-2 bg-red text-base normal-case text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 font-bold'
        >
          Cancel
        </Button>
        <Button
          variant='contained'
          disabled={Object.values(contact).some(v => !v.isValid)} 
          onClick={() => handleConfirm('byConfirm')}
          className={`shadow-sm px-3 py-2 text-base normal-case text-white ${!Object.values(contact).some(v => !v.isValid) && 'bg-green'} hover:bg-green-bright focus:outline-none focus:ring-2 focus:ring-offset-2 font-bold`}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ContactInfoDialog.propTypes = {
  open: PropTypes.bool,
  toggle: PropTypes.func,
  confirm: PropTypes.func
}

export default ContactInfoDialog;